import {Icon, Text} from "@chakra-ui/react";
import {ComponentProps, Dispatch, memo, SetStateAction, useCallback, useMemo} from "react";
import {MapPinIcon} from "@heroicons/react/16/solid";
import {Button} from "../../../../../../../../components/ui/button";
import {Tooltip} from "../../../../../../../../components/ui/tooltip";
import {CELL_SIZE} from "../../utility/types";
import {Vec2} from "../../utility/math/vec2";
import {Camera} from "../../utility/camera";
import {useUiPointerEvents} from "../../utility/uiPointerEventsContext";

const TOOLTIP_POSITIONING: ComponentProps<typeof Tooltip>["positioning"] = {placement: "top"};

export const PositionControl = memo(
  ({camera, setCamera}: {camera: Camera; setCamera: Dispatch<SetStateAction<Camera>>}) => {
    const pointerEvents = useUiPointerEvents();

    const text = useMemo(
      () => `(${(camera.position.x / CELL_SIZE).toFixed(0)}, ${(camera.position.y / CELL_SIZE).toFixed(0)})`,
      [camera.position.x, camera.position.y],
    );

    const reset = useCallback(() => {
      setCamera(prev => {
        const next = prev.clone();
        next.targetPosition = Vec2.zero();
        return next;
      });
    }, [setCamera]);

    return (
      <Tooltip content="Reset position" positioning={TOOLTIP_POSITIONING}>
        <Button
          pointerEvents={pointerEvents}
          size="xs"
          rounded="md"
          shadow="md"
          variant="ghost"
          bg="white"
          onClick={reset}
        >
          <Icon asChild color="fg.muted">
            <MapPinIcon />
          </Icon>
          <Text fontSize="xs" color="fg.muted" minW={20} fontWeight="normal" fontFamily="monospace">
            {text}
          </Text>
        </Button>
      </Tooltip>
    );
  },
);
